(function () {
  'use strict';

  var DEBUG = /[?&]spdebug=1/.test(location.search);
  function log() { if (DEBUG) console.log.apply(console, ['[HIDEit SP]'].concat([].slice.call(arguments))); }

  var SP_PRODUCT_ID = 10326520758441; // gid://shopify/Product/10326520758441
  var OPT_OUT_ATTR = 'Shipping Protection Opt-Out';
  var PRICE_SELECTOR = '[data-shipping-protection-price]';

  // Tier table: upper bound of merchandise subtotal (in cents) -> variant ID.
  // Matches the live Shipping Protection product's 20 variants exactly (HIM-SP-* SKUs).
  var TIERS = [
    { max: 9900, variantId: 51319239770281 },
    { max: 17400, variantId: 51319239803049 },
    { max: 22400, variantId: 51319239835817 },
    { max: 27400, variantId: 51319239868585 },
    { max: 34900, variantId: 51319239901353 },
    { max: 39900, variantId: 51319239934121 },
    { max: 49900, variantId: 51319239966889 },
    { max: 59900, variantId: 51319239999657 },
    { max: 69900, variantId: 51319240032425 },
    { max: 79900, variantId: 51319240065193 },
    { max: 89900, variantId: 51319240097961 },
    { max: 99900, variantId: 51319240130729 },
    { max: 149900, variantId: 51319240163497 },
    { max: 199900, variantId: 51319240196265 },
    { max: 249900, variantId: 51319240229033 },
    { max: 299900, variantId: 51319240261801 },
    { max: 349900, variantId: 51319240294569 },
    { max: 399900, variantId: 51319240327337 },
    { max: 449900, variantId: 51319240360105 },
    { max: 500000, variantId: 51319240392873 }
  ];

  /*
   * v4 - 2026-10-20 - Tier boundaries now cover the cents between ranges: a tier
   * labelled "1-99" (max 9900) covers everything below $100.00, so $99.50 stays in
   * 1-99 instead of jumping to 100-174. This matches the checkout extension's tier
   * rule exactly (it picks the highest tier whose minimum is <= subtotal), so the
   * cart and checkout can never disagree on a cart like $99.50.
   */
  function tierForSubtotal(cents) {
    for (var i = 0; i < TIERS.length; i++) {
      if (cents < TIERS[i].max + 100) return TIERS[i];
    }
    return TIERS[TIERS.length - 1];
  }

  /*
   * v4 - 2026-10-20 - Per Umair: when the shopper unticks Shipping Protection the price
   * badge said "Free", and only showed a price when ticked. Unticked removes the
   * line from the cart, so there was no line price to read and it fell back to "Free".
   * It now shows what protection WOULD cost for this cart, as "+$2.75", read live
   * from the product's real variant prices (never hardcoded, so price edits in Admin
   * flow through). The product handle is learned from the cart line the first time
   * protection is in the cart and remembered; a data-shipping-protection-handle
   * attribute on the price element (optional) or the default handle are fallbacks.
   * v4.1 - the price text is only rewritten when it actually changes. Rewriting the
   * same text counted as a drawer change, which woke this script's own watcher (and
   * the shipping-estimate script) every few hundred ms in an endless quiet loop.
   */
  var HANDLE_KEY = 'hideit_sp_handle';
  var DEFAULT_HANDLE = 'shipping-protection';
  var variantPrices = null;    // { variantId: cents }
  var pricesLoading = null;

  function rememberHandle(line) {
    if (!line || !line.handle) return;
    try { localStorage.setItem(HANDLE_KEY, line.handle); } catch (e) { /* storage blocked */ }
  }

  function spHandle() {
    var el = document.querySelector('[data-shipping-protection-handle]');
    if (el && el.getAttribute('data-shipping-protection-handle')) return el.getAttribute('data-shipping-protection-handle');
    try {
      var saved = localStorage.getItem(HANDLE_KEY);
      if (saved) return saved;
    } catch (e) { /* storage blocked */ }
    return DEFAULT_HANDLE;
  }

  function loadVariantPrices() {
    if (variantPrices) return Promise.resolve(variantPrices);
    if (pricesLoading) return pricesLoading;
    pricesLoading = fetch(root + 'products/' + spHandle() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (product) {
        if (Number(product.id) !== SP_PRODUCT_ID) throw new Error('handle is not the Shipping Protection product');
        var map = {};
        (product.variants || []).forEach(function (v) { map[v.id] = v.price; });
        variantPrices = map;
        log('variant prices loaded', map);
        return map;
      })
      .catch(function (err) {
        log('could not load variant prices', err);
        pricesLoading = null;
        return null;
      });
    return pricesLoading;
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var queued = false;

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function findSPLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === SP_PRODUCT_ID) return cart.items[i];
    }
    return null;
  }

  function isOptedOut(cart) {
    return !!(cart.attributes && cart.attributes[OPT_OUT_ATTR] === 'true');
  }

  function addLine(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _hideit_shipping_protection: 'true' } }] })
    }).then(function (r) { return r.json(); });
  }

  function removeLine(key) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function setOptOut(value) {
    var attrs = {};
    attrs[OPT_OUT_ATTR] = value ? 'true' : 'false';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  /*
   * v2 - 2026-10-17 - Per Rey: desktop showed "Shipping Protection ... Free" while mobile
   * correctly showed "$1.00" for the same cart. Root cause: the price in
   * sections/cart.liquid's shipping-protection block is rendered server-side from
   * cart.items at the moment the page loads - if that happens before this script's
   * reconcile() has finished adding the real tier variant (a few hundred ms, over the
   * network), sp_line is still null and the block falls back to its "Free" copy. The
   * block never gets corrected after that unless something else happens to force a
   * section re-render. Mobile just happened to catch a cart that had already been
   * reconciled (e.g. from an earlier add-to-cart); a fresh desktop page load didn't.
   * Fix: write the real price into the page directly, the moment we know it, instead of
   * relying on an uncertain re-render elsewhere. Scoped to [data-shipping-protection-price]
   * (the cart page's existing price span) - doesn't touch markup, doesn't add a dependency
   * on Shopify.money_format being set (falls back to a plain $X.XX string, which matches
   * the storefront's own {{ amount | money }} output since the store uses USD).
   */
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
    } catch (e) { /* fall through to plain formatting below */ }
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePriceDisplays(cart) {
    var els = document.querySelectorAll(PRICE_SELECTOR);
    if (!els.length) return;

    var spLine = findSPLine(cart);
    if (spLine) {
      rememberHandle(spLine);
      var lineText = formatMoney(spLine.final_line_price);
      els.forEach(function (el) {
        if (el.textContent.trim() !== lineText) el.textContent = lineText;
      });
      return;
    }

    var merchandise = cart.total_price;
    if (cart.item_count === 0 || merchandise <= 0) {
      els.forEach(function (el) {
        var freeText = el.getAttribute('data-shipping-protection-free-label') || 'Free';
        if (el.textContent.trim() !== freeText) el.textContent = freeText;
      });
      return;
    }

    // No protection line: show the price for this cart's tier.
    // Opted out -> "+$2.75" (what ticking the box would add).
    // Not opted out -> "$2.75" (the line reconcile() is about to add).
    var tier = tierForSubtotal(merchandise);
    var prefix = isOptedOut(cart) ? '+' : '';
    loadVariantPrices().then(function (prices) {
      if (!prices || prices[tier.variantId] == null) return; // leave the page as is
      var text = prefix + formatMoney(prices[tier.variantId]);
      document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
        if (el.textContent.trim() !== text) el.textContent = text;
      });
    });
  }

  /*
   * v3 - 2026-10-17 - Confirmed via theme.js: the theme's own <cart-items> element
   * (the thing that actually re-fetches and re-renders the visible line-item list and
   * subtotal) listens ONLY for the "theme:cart:refresh" event - there is no listener
   * for the generic "cart:refresh" anywhere in the theme bundle. This script was only
   * ever dispatching "cart:refresh", so when it silently added/removed/swapped the
   * Shipping Protection line in the background (page load, toggle change, cart total
   * crossing a tier), the real cart was correct but the visible item list and subtotal
   * could go stale until something else (e.g. the shopper changing another item's
   * quantity) happened to fire the real event. Dispatching "theme:cart:refresh" too
   * closes that gap. (The Shipping Protection price badge itself is still handled by
   * updatePriceDisplays() above, not by this refresh - the theme's own re-render,
   * sections/api-cart-items.liquid, only covers line items + subtotal, not that block.)
   */
  function announce(cart) {
    updatePriceDisplays(cart);
    document.dispatchEvent(new CustomEvent('hideit:shipping-protection:updated', { detail: cart, bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return cart;
  }

  function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;

    getCart().then(function (cart) {
      updatePriceDisplays(cart);

      var spLine = findSPLine(cart);
      var optedOut = isOptedOut(cart);
      var merchandiseSubtotal = cart.total_price - (spLine ? spLine.final_line_price : 0);

      if (optedOut) {
        if (spLine) {
          log('opted out, removing SP line');
          return removeLine(spLine.key).then(getCart).then(announce);
        }
        return null;
      }

      if (merchandiseSubtotal <= 0) {
        if (spLine) {
          log('cart emptied out, removing SP line');
          return removeLine(spLine.key).then(getCart).then(announce);
        }
        return null;
      }

      var tier = tierForSubtotal(merchandiseSubtotal);

      if (!spLine) {
        log('adding SP line, tier variant', tier.variantId);
        return addLine(tier.variantId).then(getCart).then(announce);
      }

      if (spLine.variant_id !== tier.variantId) {
        log('swapping SP tier', spLine.variant_id, '->', tier.variantId);
        return removeLine(spLine.key)
          .then(function () { return addLine(tier.variantId); })
          .then(getCart)
          .then(announce);
      }

      return null;
    }).catch(function (err) {
      log('reconcile failed', err);
    }).finally(function () {
      busy = false;
      if (queued) { queued = false; reconcile(); }
    });
  }

  // --- Toggle wiring (cart page; event-delegated so it survives section re-renders) ---
  document.addEventListener('change', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-shipping-protection-toggle]');
    if (!toggle) return;
    log('toggle changed, checked =', toggle.checked);
    setOptOut(!toggle.checked).then(function () {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      reconcile();
    });
  });

  // --- Trigger points ---
  document.addEventListener('theme:cart:refresh', function () { reconcile(); });
  document.addEventListener('cart:refresh', function () { reconcile(); });

  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 400);
  });

  var started = false;
  function start() {
    if (started) return;
    started = true;
    ['[data-api-cart-price]', '#cartItemsHolder', '.cart-drawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();